import { render, staticRenderFns } from "./FreightTablesFilterModal.vue?vue&type=template&id=082862b1&scoped=true"
import script from "./FreightTablesFilterModal.vue?vue&type=script&lang=js"
export * from "./FreightTablesFilterModal.vue?vue&type=script&lang=js"
import style0 from "./FreightTablesFilterModal.vue?vue&type=style&index=0&id=082862b1&prod&scoped=true&lang=less"
import style1 from "./FreightTablesFilterModal.vue?vue&type=style&index=1&id=082862b1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082862b1",
  null
  
)

export default component.exports